/* ReviewFormModal.styles.ts generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"],
  _excluded6 = ["as", "style"],
  _excluded7 = ["as", "style"],
  _excluded8 = ["as", "style"],
  _excluded9 = ["as", "style"],
  _excluded10 = ["as", "style"],
  _excluded11 = ["as", "style"],
  _excluded12 = ["as", "style"],
  _excluded13 = ["as", "style"],
  _excluded14 = ["as", "style"],
  _excluded15 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _47 = "._syaz1tmw{color:var(--ds-text-danger,#ae2e24)}";
const _46 = "._18s8yan9{margin:0 0 var(--ds-space-025,2px) var(--ds-space-050,4px)}";
const _45 = "._18s8gagk{margin:var(--ds-space-050,4px) 0 0 var(--ds-space-050,4px)}";
const _44 = "._ffi4viql._ffi4viql{line-height:2rem}";
const _43 = "._1w901gjq._1w901gjq{color:var(--ds-text-subtle,#44546f)}";
const _42 = "._6w2lidpf._6w2lidpf:focus{padding-left:0}";
const _41 = "._p5ygidpf._p5ygidpf:focus{padding-bottom:0}";
const _40 = "._10vnidpf._10vnidpf:focus{padding-right:0}";
const _39 = "._fxxjidpf._fxxjidpf:focus{padding-top:0}";
const _38 = "._1dqtu2gc._1dqtu2gc{gap:var(--ds-space-100,8px)}";
const _37 = "._1yxxidpf._1yxxidpf{padding-left:0}";
const _36 = "._fjwridpf._fjwridpf{padding-bottom:0}";
const _35 = "._w8sqidpf._w8sqidpf{padding-right:0}";
const _34 = "._1dltidpf._1dltidpf{padding-top:0}";
const _33 = "._4t3it9kd{height:72px}";
const _32 = "._n7zlzgxb{border-bottom:1px solid var(--ds-border,#091e4224)}";
const _31 = "._4cvr1h6o{align-items:center}";
const _30 = "._1bahesu3{justify-content:flex-end}";
const _29 = "._1e0c1txw{display:flex}";
const _28 = "._zulpu2gc{gap:var(--ds-space-100,8px)}";
const _27 = "._1yt4q6zc{padding:var(--ds-space-200,1pc) var(--ds-space-300,24px) var(--ds-space-300,24px) var(--ds-space-300,24px)}";
const _26 = "._h0os1tmw._h0os1tmw~span:after{color:var(--ds-text-danger,#ae2e24)}";
const _25 = "._yrsujphk._yrsujphk~span:after{content:\"*\"}";
const _24 = "._6e2d1gjq._6e2d1gjq~span{color:var(--ds-text-subtle,#44546f)}";
const _23 = "._43v0po1d._43v0po1d~span{font-family:var(--ds-font-family-brand-body,\"Charlie Text\",ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,system-ui,\"Helvetica Neue\",sans-serif)}";
const _22 = "._19pkutpp{margin-top:var(--ds-space-150,9pt)}";
const _21 = "._ffi41k8s._ffi41k8s{line-height:1.5rem}";
const _20 = "._1w901fxt._1w901fxt{color:var(--ds-text,#172b4d)}";
const _19 = "._1i921j6v._1i921j6v{font-size:1rem}";
const _18 = "._18x3po1d._18x3po1d{font-family:var(--ds-font-family-brand-body,\"Charlie Text\",ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,system-ui,\"Helvetica Neue\",sans-serif)}";
const _17 = "._ect4po1d{font-family:var(--ds-font-family-brand-body,\"Charlie Text\",ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,system-ui,\"Helvetica Neue\",sans-serif)}";
const _16 = "._otyru2gc{margin-bottom:var(--ds-space-100,8px)}";
const _15 = "._1e0c1o8l{display:inline-block}";
const _14 = "@media not all and (min-width:48rem){._14adpxbi{margin-bottom:var(--ds-space-200,1pc)}}";
const _13 = "._otyr1b66{margin-bottom:var(--ds-space-050,4px)}";
const _12 = "._19pkidpf{margin-top:0}";
const _11 = "._18s81jx0{margin:var(--ds-space-400,2pc) 0}";
const _10 = "._1m9k1tmw>span{color:var(--ds-text-danger,#ae2e24)}";
const _9 = "._syaz1gjq{color:var(--ds-text-subtle,#44546f)}";
const _8 = "@media not all and (min-width:48rem){._15tx1ejb{padding:var(--ds-space-300,24px)}}";
const _7 = "._1yt41e2i{padding:0 var(--ds-space-300,24px)}";
const _6 = "@media not all and (min-width:48rem){._1ykzu2gc{padding-bottom:var(--ds-space-100,8px)}}";
const _5 = "._1yt4qbs9{padding:var(--ds-space-300,24px) var(--ds-space-300,24px) var(--ds-space-200,1pc) var(--ds-space-300,24px)}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Checkbox } from '@atlaskit/checkbox';
import { media } from '@atlaskit/primitives/responsive';
import TextArea from '@atlaskit/textarea';
import { BodySmall, Button, FinePrint } from '@atlassian/mpac-primitives';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _4 = "._4t3i1osq{height:100%}";
const _3 = "._16qs1cd0{box-shadow:var(--ds-shadow-overlay,0 8px 9pt #091e4226,0 0 1px #091e424f)}";
const _2 = "._2rko1hfi{border-radius:.187rem}";
const _ = "._11q71bhr{background:var(--ds-surface-overlay,#fff)}";
export const Overlay = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_11q71bhr _2rko1hfi _16qs1cd0 _4t3i1osq", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Overlay.displayName = 'Overlay';
}
export const Header = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_5, _6]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1yt4qbs9 _1ykzu2gc", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Header.displayName = 'Header';
}
export const Body = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_7, _8]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1yt41e2i _15tx1ejb", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Body.displayName = 'Body';
}
export const RequiredMessage = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = FinePrint,
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_9, _10]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_syaz1gjq _1m9k1tmw", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  RequiredMessage.displayName = 'RequiredMessage';
}
export const RatingsWrapper = forwardRef((_ref5, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_11]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_18s81jx0", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  RatingsWrapper.displayName = 'RatingsWrapper';
}
export const RatingsLabel = forwardRef((_ref6, __cmplr) => {
  let {
      as: C = BodySmall,
      style: __cmpls
    } = _ref6,
    __cmplp = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_9, _12, _13, _10, _14]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_syaz1gjq _19pkidpf _otyr1b66 _1m9k1tmw _14adpxbi", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  RatingsLabel.displayName = 'RatingsLabel';
}
export const ReviewLabel = forwardRef((_ref7, __cmplr) => {
  let {
      as: C = "label",
      style: __cmpls
    } = _ref7,
    __cmplp = _objectWithoutProperties(_ref7, _excluded7);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_15, _9, _16, _17]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1o8l _syaz1gjq _otyru2gc _ect4po1d", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ReviewLabel.displayName = 'ReviewLabel';
}
export const ReviewTextArea = forwardRef((_ref8, __cmplr) => {
  let {
      as: C = TextArea,
      style: __cmpls
    } = _ref8,
    __cmplp = _objectWithoutProperties(_ref8, _excluded8);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_18, _19, _20, _21]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_18x3po1d _1i921j6v _1w901fxt _ffi41k8s", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ReviewTextArea.displayName = 'ReviewTextArea';
}
export const UserConsentCheckboxWrapper = forwardRef((_ref9, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref9,
    __cmplp = _objectWithoutProperties(_ref9, _excluded9);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_22, _14]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pkutpp _14adpxbi", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  UserConsentCheckboxWrapper.displayName = 'UserConsentCheckboxWrapper';
}
export const UserConsentCheckbox = forwardRef((_ref10, __cmplr) => {
  let {
      as: C = Checkbox,
      style: __cmpls
    } = _ref10,
    __cmplp = _objectWithoutProperties(_ref10, _excluded10);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_23, _24, _25, _26]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_43v0po1d _6e2d1gjq _yrsujphk _h0os1tmw", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  UserConsentCheckbox.displayName = 'UserConsentCheckbox';
}
export const Footer = forwardRef((_ref11, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref11,
    __cmplp = _objectWithoutProperties(_ref11, _excluded11);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_27, _28, _29, _30, _31]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1yt4q6zc _zulpu2gc _1e0c1txw _1bahesu3 _4cvr1h6o", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Footer.displayName = 'Footer';
}
export const HeaderMobile = forwardRef((_ref12, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref12,
    __cmplp = _objectWithoutProperties(_ref12, _excluded12);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_7, _, _32, _29, _31, _33]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1yt41e2i _11q71bhr _n7zlzgxb _1e0c1txw _4cvr1h6o _4t3it9kd", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  HeaderMobile.displayName = 'HeaderMobile';
}
export const NavBackButton = forwardRef((_ref13, __cmplr) => {
  let {
      as: C = Button,
      style: __cmpls
    } = _ref13,
    __cmplp = _objectWithoutProperties(_ref13, _excluded13);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _19, _44]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1dltidpf _w8sqidpf _fjwridpf _1yxxidpf _1dqtu2gc _fxxjidpf _10vnidpf _p5ygidpf _6w2lidpf _1w901gjq _1i921j6v _ffi4viql", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  NavBackButton.displayName = 'NavBackButton';
}
export const ErrorWrapper = forwardRef((_ref14, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref14,
    __cmplp = _objectWithoutProperties(_ref14, _excluded14);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_45, _29, _31]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_18s8gagk _1e0c1txw _4cvr1h6o", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ErrorWrapper.displayName = 'ErrorWrapper';
}
export const ErrorText = forwardRef((_ref15, __cmplr) => {
  let {
      as: C = FinePrint,
      style: __cmpls
    } = _ref15,
    __cmplp = _objectWithoutProperties(_ref15, _excluded15);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_46, _47]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_18s8yan9 _syaz1tmw", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ErrorText.displayName = 'ErrorText';
}